export const headerName = {
    add: "Добавить тип маломерного судна",
    edit: "Редактировать тип маломерного судна",
};
export const boatTypesInputs = {
    btname: {
        key: "btname",
        label: "Наименование типа маломерного судна",
        type: "text",
        required: true,
    },
    btnote: {
        key: "btnote",
        label: "Примечание",
        type: "text",
        required: false,
    },
}
export const getBoatTypesInputs = ()=>boatTypesInputs